import isObjectLike from "lodash/isObjectLike";
import pickBy from "lodash/pickBy";
import omitBy from "lodash/omitBy";
import isNil from "lodash/isNil";

export function isCompletelyEmpty(filteredModel) {
  if (!filteredModel) {
    return true;
  }
  if (!isObjectLike(filteredModel)) {
    throw new TypeError("isCompletelyEmpty func only accepts objects.");
  }
  const embedded = pickBy(filteredModel, x => isObjectLike(x));
  const filtered = omitBy(filteredModel, isObjectLike);
  const subset = pickBy(filtered, x => isNil(x) || x === "");

  const ek = Object.keys(embedded);
  if (ek.length > 0) {
    return (
      ek.filter(x => isCompletelyEmpty(embedded[x])).length > 0 &&
      Object.keys(subset).length === Object.keys(filtered).length
    );
  }

  return Object.keys(subset).length === Object.keys(filtered).length;
}
